import { useIsMutating } from '@tanstack/react-query';
import { useMemo } from 'react';
import { mutationProjectKeys } from '@/enteties/project/api/projects.query-key';
import type { Project } from '@/enteties/project/modal';

export const useIsProjectControlButtonDisabled = (
  project: Project | undefined,
  slug: string,
  buildORRun: boolean = false
) => {
  const scalingPending = useIsMutating({
    mutationKey: mutationProjectKeys.scalingProject(slug),
  });

  const isDisabled = useMemo(() => {
    if (!project) return true;
    const isBuildOrRun = buildORRun && project.status === 'BUILD_STARTED';
    return (
      !!scalingPending ||
      isBuildOrRun ||
      project.status === '' ||
      project.status === 'CREATING'
      // customChecks
    );
  }, [buildORRun, project, scalingPending]);

  return isDisabled;
};
